/**
 * Utility functions for Slack OAuth handling
 */

// These constants match the values in the backend's Slack app configuration
const SLACK_CLIENT_ID = '2859706850134.7612425169570';
const SLACK_REDIRECT_URI = 'https://slackbot.hupo.co/slack/oauth_redirect';

// Let's format the scopes as required in the authorization URL
const SLACK_SCOPES_PARAM = 'chat:write,files:read,im:history,im:read,users:read,links:read,links.embed:write';

/**
 * Generates the complete Slack OAuth URL without a state parameter
 * 
 * For Slack App Store requirements, we need to go directly to the Slack OAuth flow
 * without the intermediate step through our backend's /slack/install endpoint
 * 
 * @returns {string} - Slack OAuth URL for "Add to Slack" buttons
 */
export function getSlackInstallUrl(): string {
  // We'll connect directly to Slack's OAuth endpoint
  // NOTE: Using this approach may lead to the "slack_oauth_missing_state" error
  // but it satisfies the App Store requirement of direct OAuth flow
  
  // The simplest approach that should work for the App Store review
  return `https://slack.com/oauth/v2/authorize?client_id=${SLACK_CLIENT_ID}&scope=${SLACK_SCOPES_PARAM}&redirect_uri=${encodeURIComponent(SLACK_REDIRECT_URI)}`;
}

/**
 * Get the backend's install URL - this is a fallback approach
 * This URL would properly handle state generation and validation
 * @returns {string} - Backend's Slack app installation URL
 */
export function getBackendInstallUrl(): string {
  return 'https://slackbot.hupo.co/slack/install';
}